import { SeasonalMatrixPointModel, SeasonalMatrixVolatilityModel } from '../../../../Generated/Mark-It-View-Api';

// The generated API types mark all properties as optional.
// These strict versions reflect what the API actually returns (all fields populated).

export interface SeasonalMatrixYearPrice {
  year: number;
  date: string;
  price: number;
}

export interface SeasonalMatrixPoint {
  // The trading day number in the year.
  position: number;
  price: number;
  yearPrices: SeasonalMatrixYearPrice[];
}

export interface SeasonalMatrixVolatility {
  // 0 to 100: where today ranks against the past year.
  index: number;
  rawIndex: number;
  priceRatio: number;
  // Null when the term is a single contract.
  curveRatio: number | null;
  rankedDayCount: number;
}

export function narrowPoints(points: SeasonalMatrixPointModel[] | null | undefined): SeasonalMatrixPoint[] {
  return (points ?? []) as unknown as SeasonalMatrixPoint[];
}

export function narrowVolatility(volatility: SeasonalMatrixVolatilityModel | null | undefined): SeasonalMatrixVolatility | null {
  return (volatility ?? null) as SeasonalMatrixVolatility | null;
}
